/* TUR scroll-reveal — lightweight, no dependencies.
   Reveals elements with .tur-reveal / .tur-stagger as they enter the viewport.
   Hidden state is scoped to .tur-anim-ready (set in <head>), so with JS off or
   reduced-motion on, nothing is ever hidden. */
(function () {
  window.__turAnim = true;

  /* Lazy-mount video embeds (runs regardless of motion prefs) — nothing loads
     until the section is near the viewport, keeping initial page load fast. */
  (function () {
    var frames = document.querySelectorAll('iframe[data-src]');
    if (!frames.length) return;
    function mount(f) { if (f.dataset.src) { f.src = f.dataset.src; f.removeAttribute('data-src'); } }
    if (!('IntersectionObserver' in window)) { frames.forEach(mount); return; }
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { mount(e.target); vio.unobserve(e.target); } });
    }, { rootMargin: '300px 0px' });
    frames.forEach(function (f) { vio.observe(f); });
  })();

  if (!document.documentElement.classList.contains('tur-anim-ready')) return;
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.tur-reveal, .tur-stagger').forEach(function (el) {
      el.classList.add('is-in');
    });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

  function observe() {
    document.querySelectorAll('.tur-reveal:not(.is-in), .tur-stagger:not(.is-in)').forEach(function (el) {
      io.observe(el);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
})();
